import axios from "axios";
import config from '../config/configJS';

const axiosApi = axios.create({
    baseURL: config.endPoint
});

let isInterceptorEjected = false;

export const responseInterceptor = () => axiosApi.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    
    const prevRequest = error?.config;
    if (401 === error.response.status) {    
        isInterceptorEjected = true;
        prevRequest.sent = true;
        window.location = '/Login'; 
    } 
    return Promise.reject(error);
  });

axiosApi.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem('accessToken');
  if (!!accessToken) {
    config.headers['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`;
    config.headers['ad'] = `true`;

  }


  return config;
});

  export default axiosApi;

